// https://icon.intra.xiaojukeji.com/#/user/535/repo/321
export const defaultIcon = 'gattaran-moren';
export default {
  'CustomerManagement$$icon-baifang': '客户管理$$gattaran-kehuguanli',
  'ShopOp$$icon-kefu': '商户运营$$gattaran-shanghuyunying',
  'OpenApi$$icon-empty': 'OpenAPI开放后台$$gattaran-kaifangpingtai', // ??
  'StoreOperateTask$$icon-note': '销售团队任务$$gattaran-xiaoshoutuanduirenwu',
  'BDManage$$icon-guanli': 'BD管理$$gattaran-BDguanli',
  'itemManage$$icon-filled_store': '菜品管理$$gattaran-caipinguanli',
  'CRM$$icon-yonghu': 'CRM$$gattaran-CRM',
  'Operations$$icon-yunyingweiguanli': '用户营销$$gattaran-yonghuyingxiao',
  'homeConf$$icon-gongzuotai': '用户端首页运营$$gattaran-yonghuduanshouyeyunying',
  'Admanage$$icon-growth': '新客增长$$gattaran-xinkezengchang',
  'FeatureDelivery$$icon-viewpingpushitu': '功能投放$$gattaran-gongnengtoufang',
  transaction_mis_cal_conf: '互斥关系$$gattaran-huchiguanxi',
  'topic$$icon-shangquan': 'topic生产配置平台$$gattaran-topicliebiao',
  'SupplyManage$$icon-peisong': '供需管理$$gattaran-gongxuguanli',
  'RiderOp$$icon-jiankong': '骑手运营$$gattaran-qishouyunying',
  'Finance$$icon-caiwuguanli': '财务$$gattaran-caiwu',
  'CityConfManage$$icon-celve': '城市配置管理$$gattaran-chengshipeizhiguanli',
  'ManageTransactions$$icon-order': '交易管理$$gattaran-jiaoyiguanli',
  'EquipmentCenter$$icon-tool': '物料仓储$$gattaran-kaifangpingtai',
  'OpFight$$icon-huodong': '天机$$gattaran-tianji',
  'tagcenter$$icon-shuju': '标签中心$$gattaran-biaoqianzhongxin',
  'ControlPlatform$$icon-qishouguanli': '控制台$$gattaran-kaifangpingtai',
  'Task System$$icon-todo': '任务$$gattaran-renwu',
  'auditMenu$$icon-filter': '审核$$gattaran-shenhe',
  'Message$$message-center': '消息中心$$gattaran-xiaoxizhongxin2',
  'application$$/authmanage/application/list': '我的申请$$gattaran-wentifankui2',
  'pplication$$/authmanage/myrole': '我的角色$$gattaran-kehuguanli',
  'audirtasklist$$/mcenter/audit/myTaskList/myTask/team': '我的审核$$gattaran-shenhe',
  'learningCenter$$https://food-learning.didiglobal.com': '学习中心$$gattaran-xuexizhongxin',
};
